const ROLES = {
    ADMIN: 100,
    ALL: [0, 1, 2, 3, 4, 5, 100],
    ELEVATED: [1, 2, 3, 4, 5],
    DEFAULT: 0,
    BIOINFORMATICS: 1,
    BIOLOGIST: 2,
    APPROVER: 3,
    BIOOPS: 4,
    DCT: 5,
};

export default ROLES;